var map = {
	"./advantages.js": [
		615,
		615
	],
	"./app.js": [
		80
	],
	"./average.js": [
		634,
		634
	],
	"./banner.js": [
		19,
		19
	],
	"./breadcrumbs.js": [
		998,
		998
	],
	"./card-consect.js": [
		27,
		27
	],
	"./card-post.js": [
		485,
		485
	],
	"./contact-us.js": [
		391,
		391
	],
	"./content.js": [
		43,
		43
	],
	"./excellent.js": [
		944,
		944
	],
	"./finding.js": [
		783,
		783
	],
	"./footer.js": [
		404,
		404
	],
	"./header.js": [
		851,
		851
	],
	"./intro-text.js": [
		996,
		996
	],
	"./intro.js": [
		255,
		255
	],
	"./investor-section.js": [
		457,
		457
	],
	"./jingle.js": [
		520,
		520
	],
	"./latest.js": [
		922,
		922
	],
	"./modal.js": [
		331,
		331
	],
	"./progress-section.js": [
		66,
		66
	],
	"./project.js": [
		801,
		801
	],
	"./text.js": [
		571,
		571
	],
	"./vision.js": [
		145,
		145
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 528;
module.exports = webpackAsyncContext;